














import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import { Select } from '@/pages/profile/blocks';
import { MONTHS_OF_THE_YEAR, YEARS, CURRENT_YEAR } from './consts';
import { DateType } from './types';

@Component({
  components: {
    Select,
  },
})
export default class FilterSelectBlock extends Vue {
  @Prop({ type: String, default: '1' })
  readonly monthValue!: string;

  @Prop({ type: String, default: '2020' })
  readonly monthYear!: string;

  months: DateType = MONTHS_OF_THE_YEAR;
  years: DateType = YEARS;

  onChangeYear(value: string) {
    this.$emit('yearChange', value);
  }

  onChangeMonth(value: string) {
    this.$emit('monthChange', value);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/components/filterselect/FilterSelectBlock.vue